"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageDialogsProvider = void 0;
var home_page_dialogs_provider_1 = require("./home-page-dialogs.provider");
Object.defineProperty(exports, "HomePageDialogsProvider", { enumerable: true, get: function () { return home_page_dialogs_provider_1.HomePageDialogsProvider; } });
